import { produce } from 'immer';

import { CloseCampaignPlaceEditor } from '../../actions/campaignPlaceEditor/closeCampaignPlaceEditor';
import { CampaignPlaceEditorState } from '../../typings/campaignPlaceEditor';

export function closeCampaignPlaceEditor(
    state: CampaignPlaceEditorState,
    action: CloseCampaignPlaceEditor
): CampaignPlaceEditorState {
    return produce(state, draft => {
        const { editorId } = action;

        draft[editorId].isOpen = false;
    });
}
